import { CountUp } from 'countup.js';

window.onload = function () {
    document.querySelectorAll('span[class*="stat-value"]').forEach(ele => {

        let options = {
            duration: 1.5,
            decimalPlaces: 1,
        }
        console.log(ele.className.split(" "))

        const countupStrings = ele.className.split(" ").filter(cn => cn.startsWith("countup"));
        if (countupStrings.length > 0) {
            let d = countupStrings[0].split('-')[1]
            if (!isNaN(Number(d))) {
                options.decimalPlaces = Number(d)
            }
        }

        let val = ele.innerHTML
        v = Number(val)
        //console.log(val, typeof(val), v, typeof(v), isNaN(v))
        if (!isNaN(v)) {
            var countUp = new CountUp(ele, val, options);
            if (!countUp.error) {
                countUp.start();
            } else {
                console.error(countUp.error);
            }
        }
    });
}